import { Stack, Typography } from "@mui/material";
import TextEditor, { type TextEditorBasicProps } from "components/TextEditor";
import { FieldValues, RegisterOptions, useController, useFormContext } from "react-hook-form";

interface TextEditorControlsProps extends TextEditorBasicProps {
  name: string;
  label?: string;
  rules?:
    | Omit<RegisterOptions<FieldValues, string>, "disabled" | "valueAsNumber" | "valueAsDate" | "setValueAs">
    | undefined;
}

const TextEditorControls = ({ name, label, rules, ...props }: TextEditorControlsProps) => {
  const { control } = useFormContext();

  const {
    field,
    fieldState: { invalid },
  } = useController({
    name,
    control,
    rules,
  });

  return (
    <Stack spacing={0.5}>
      {label && (
        <Typography
          variant='body14rg'
          sx={{ color: "base.500" }}>
          {label}
        </Typography>
      )}
      <TextEditor
        value={field.value}
        onChange={field.onChange}
        isValid={!invalid}
        {...props}
      />
    </Stack>
  );
};

export default TextEditorControls;
